import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'sbd-doug-frontend-task-date-time-picker',
  standalone: true,
  imports: [
    CommonModule,
    MatCheckbox,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatFormField,
    MatError,
    MatInput,
    MatLabel,
    MatSuffix,
    ReactiveFormsModule,
  ],
  templateUrl: './task-date-time-picker.component.html',
})

export class TaskDateTimePickerComponent implements OnInit{
  @Input() formGroup: FormGroup;
  @Output() onDateTimePicked: EventEmitter<any> = new EventEmitter<any>();
  _changeDetector = inject(ChangeDetectorRef);
  @Input() ignoreTime!: any;


  ngOnInit() {

    /*TIME MANIPULATOR*/
    this.formGroup.get('ignore_time').valueChanges.subscribe((value) => {
      if (value === true) {
        this.formGroup.get('task_due_time').setValue('23:59');
        this.formGroup.get('task_due_time').disable();
        this.ignoreTime = true;
      } else {
        this.formGroup.get('task_due_time').enable();
        this.ignoreTime = false;
      }
      this.buildDate(this.formGroup.get('task_due_time').value);
    });

    this.formGroup.get('task_due_time').valueChanges.subscribe((value) => {
      this.buildDate(value);
    });

    this.formGroup.get('task_due_date').valueChanges.subscribe((value) => {
      this.buildDate(this.formGroup.get('task_due_time').value);
    });
    /*END TIME MANIPULATOR*/

    this._changeDetector.detectChanges();
  }


  buildDate(timeInput: string): void {
    if (!timeInput) return;

    // Split the input into hours and minutes
    const [hours, minutes] = timeInput.split(':').map(Number);

    // Get the task due date from the form and parse it as a Date object
    const taskDueDateValue = this.formGroup.get('task_due_date')?.value;
    if (!taskDueDateValue) return;

    const localDate = new Date(taskDueDateValue);

    // Set the time components based on local time
    localDate.setHours(hours, minutes, 0, 0);

    const utcDate = new Date(localDate.toISOString());

    // Save the ISO string representation of the UTC date
    this.onDateTimePicked.emit(utcDate.toISOString());

  }


}
